// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixLocation from 'wix-location';
import wixData from 'wix-data';
import wixWindow from 'wix-window';
import {local} from 'wix-storage';



$w.onReady(function () {
	let ex_device = 'ex_desktop';
	if(wixWindow.formFactor == "Desktop"){
		$w("#text13").html = $w("#text13").html.replace("<h1",'<h1 style="width: calc(100vw - 140px); margin-left:70px;" ');
  	}else{
		 ex_device = 'ex_mobile';
  	}
	$w("#repeater1").onItemReady( ($w, itemData, index) => {
		let title_size = "ex_title29";
		let year_size = "15px";
		 if(itemData.title.length > 40){
			title_size = "ex_title20";
		}else if(itemData.title.length > 20){
			title_size = "ex_title24";
		}else if(itemData.title.length >= 18 && (itemData.title.toLowerCase().split("m").length > 2 || itemData.title.toLowerCase().split("w").length > 2 || itemData.title.split(" ").length > 2)){
			title_size = "ex_title24";
		}
		let itemhtml_html = '<div class="ex_podcast ' + ex_device + '" ><a class="ex_title"  href="' + itemData["link-podcasts-title"] + '" target="_self" ><span class="' + title_size + '">' + itemData.title + '</span></a>';
		let disciplines = itemData.discipline_tags;
		disciplines.sort(function(a,b){ if(a.length > b.length ){ return 1}else{ return -1}});
	    
		for(let i=0;i<disciplines.length;i++){
			disciplines[i] = '<a href="' + wixLocation.baseUrl + '/browse-by/discipline/' 
			+ disciplines[i].trim() + '" target="_self" ><span>'+ disciplines[i].trim() + '</span></a>';
		}
		disciplines = disciplines.join("<span> / </span>");
		itemhtml_html += '<p class="ex_disciplines" >' + disciplines + '</p>';	
		let year_html = '<p class="ex_year" ><a href="' + wixLocation.baseUrl + '/browse-by/year/' + itemData.year + '" target="_self" ><span>' + itemData.year + '</span></a></p>';
		let image_parts = itemData.photo.split("/");
		
		itemhtml_html += year_html;
		if(wixWindow.formFactor == "Desktop"){
			image_parts = "https://static.wixstatic.com/media/" + image_parts[3] + "/v1/fill/w_288,h_268,al_c,q_80,usm_0.66_1.00_0.01/" + image_parts[3]/*.split(".")[0] + ".webp"*/;
		}else{
			//image_parts = "https://static.wixstatic.com/media/" + image_parts[3] + "/v1/fill/w_256,h_238,al_c,q_80,usm_0.66_1.00_0.01/" + image_parts[3];
			image_parts = "https://static.wixstatic.com/media/" + image_parts[3] + "/v1/fill/w_512,h_476,al_c,q_80,usm_0.66_1.00_0.01/" + image_parts[3];
		}
		itemhtml_html += '<a href="' + itemData["link-podcasts-title"] + '" target="_self" ><img src="' + image_parts + '" /></a></div>';
		$w("#itemhtml").html = itemhtml_html;
  	});
	
	let lightBoxSession = local.getItem("light_box_session");
	if(lightBoxSession == null){
		if($w("#header1").style.borderColor != "#10000000"){
			setTimeout(function(){ /*local.setItem("light_box_session","true");*/ $w("#header1").style.borderColor = "#10000000"; wixWindow.openLightbox("Newsletter sign up");}, 3000);
		}
	}
});
function tuggleNavigation(){

		if($w("#dataset1").hasNext()){
			$w("#olderPostsButton").show();
		}else{
			$w("#olderPostsButton").hide();
		}
}

export function dataset1_currentIndexChanged(event, $w) {
	tuggleNavigation();
}

export function dataset1_ready(event, $w) {
	tuggleNavigation();
}

export function container1_click(event, $w) {

}

export function page1_click(event, $w) {
	
}



export function box1_click(event, $w) {
	//Add your code for this event here: 
}